import { useCallback, useState } from 'react'

export function useFormData<T>(initialValue: T) {
  const [state, setState] = useState(initialValue)

  const getItem = useCallback(
    (key: keyof T) => {
      return state[key]
    },
    [state],
  )

  const setItem = useCallback((key: keyof T, value: any) => {
    setState(oldState => ({ ...oldState, [key]: value }))
  }, [])

  return { items: state, getItem, setItem, setItems: setState }
}
